import { defineMessages } from 'react-intl';

export const contextLinkingSessionsListMessages = defineMessages({
  noSessionsFound: {
    defaultMessage: 'No sessions found', id: 'PsWxNM5czE',
    description: 'Empty state when no recent sessions are available to link',
  },
  untitledSession: {
    defaultMessage: 'Untitled Session', id: 'PxFdbpFGcr',
    description: 'Fallback label for a session without a name',
  },
  loadMore: {
    defaultMessage: 'Load more', id: 'NSGjMEMoNF',
    description: 'Button to fetch additional sessions in the list',
  },
});
